import FormSuccess from './FormSuccess';

export default FormSuccess;
